import React, { useState, useEffect } from "react";

// project-imports
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import NewGalleryItem from "./NewGalleryItem"
import BreadcrumbOne from "../../common/breadcrumb/BreadcrumbOne";
import { getGalleryFilters } from "../../utils/gallery-filter";
import { useGalleryContext } from "../../context/gallery_context";
import Spinner from "../spinner-component/SpinnerOne";
import ErrorComponent from "../error-message/ErrorComponent";
import PostYouTubeVideo from "../post/PostYouTubeVideo";
import GalleryStencil from "./GalleryStencil";
import GalleryDrawer from '../our-gallery/GalleryDrawer';
import { GoogleAnalyticsEnum, pageView, triggerFunction } from '../../utils/google-analytics';

// third-party
import { FaSpinner, FaChevronDown } from "react-icons/fa";
import FsLightbox from "fslightbox-react";
import { useParams } from "react-router-dom";

const Gallery = () => {

    // Extracting variables from context
    const { fetchGalleryData, galleryLoading, galleryError, galleryData } = useGalleryContext();

    // Getting Gallery Filter
    let galleryFilter = getGalleryFilters();

    // State variable initialization
    const [dataVisibleCount, setDataVisibleCount] = useState(16);
    const [filterItems, setFilterItems] = useState(galleryData);
    const [activeFilter, setActiveFilter] = useState(galleryFilter[0].value);
    const [dataIncrement] = useState(3);
    const [noMorePost, setNoMorePost] = useState(false);
    const [visibleItems, setVisibleItems] = useState([]);
    const [toggler, setToggler] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");
    const [stencilLoading, setStencilLoading] = useState(true);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const { cleanTitle } = useParams();

    let allGalleryItems = galleryData;

    useEffect(() => {
        setVisibleItems(filterItems?.slice(0, dataVisibleCount));
        setNoMorePost(false);
    }, [activeFilter, dataVisibleCount]);

    // Constant function
    const handleLoadMoreBtn = (e) => {
        e.preventDefault();
        let tempCount = dataVisibleCount + dataIncrement;
        if (tempCount >= filterItems?.length) {
            setNoMorePost(true);
            setVisibleItems(filterItems);
        } else {
            setDataVisibleCount(tempCount);
        }
    }

    const handleFilterChange = (filter) => {
        setActiveFilter(filter?.value);
        let tempData;
        if (filter?.value?.toLowerCase() === galleryFilter[0]?.value?.toLowerCase()) {
            tempData = allGalleryItems;
        } else {
            tempData = allGalleryItems.filter((data) => data.category.toLowerCase() === filter?.value.toLowerCase());
        }
        setFilterItems(tempData);
        setDataVisibleCount(16);
    }

    const handleVideoToggle = (url) => {
        try {
            setVideoUrl(url);
            setToggler(!toggler);
        } catch (error) {

        }
    }

    const handleOpenDrawer = (data) => {
        try {
            setOpenDrawer(true);
            setSelectedItem(data);
            triggerFunction(
                GoogleAnalyticsEnum.BUTTON,
                GoogleAnalyticsEnum.SF_TUTORIALS_DETAIL_VIEW
            );
        } catch (error) {
            console.log(
                "49 : HomeFourBlog : Error in handleOpenDrawer : ",
                error && JSON.stringify(error)
            );
        }
    };

    const handleHideDrawer = () => {
        try {
            setOpenDrawer(false);
        } catch (error) {
            console.log(
                "60 : HomeFourBlog : Error in handleHideDrawer : ",
                error && JSON.stringify(error)
            );
        }
    };

    useEffect(() => {
        // // Loading timeout
        setTimeout(() => {
            setStencilLoading(false);
        }, 1000)
    })

    if (stencilLoading) {
        // Loading stencil
        return <GalleryStencil data={visibleItems} />
    }

    return (
        <>
            <SEO title="Salesforce Tutorials | Longswitch Academy" /> {/* Set SEO title */}
            {pageView(window.location.pathname, GoogleAnalyticsEnum.SALESFORCE_TUTORIALS)}
            <Layout>
                <BreadcrumbOne
                    title="Salesforce Tutorials" // Breadcrumb title
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Salesforce Tutorials"
                />
                <div className="eduvibe-home-one-blog edu-elements-area edu-section-gap bg-image">
                    <div className="container">
                        {galleryLoading && !galleryError && <Spinner />}
                        <div className="row g-5">
                            <div className="col-lg-5">
                                <div className="section-title text-start">
                                    <span className="pre-title">video tutorials</span>
                                    <h3 className="title">Our Salesforce Tutorials</h3>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="button-group isotop-filter filters-button-group d-flex justify-content-start justify-content-lg-end fs-4">
                                    {galleryFilter.map((filter) => (
                                        <button
                                            onClick={() => handleFilterChange(filter)}
                                            // onClick={handleChange}
                                            key={filter.id}
                                            className={
                                                filter?.value.toLowerCase() === activeFilter
                                                    ? "is-checked"
                                                    : " "
                                            }
                                        >
                                            {filter.label}
                                        </button>
                                    ))}
                                </div>
                            </div>
                            <div className="col-lg-12">
                                {!galleryLoading && galleryError ?
                                    <div className="row g-5 mt--10 text-center">
                                        <ErrorComponent errorCode="500" mainError="No gallery are available!" subText="Currently no gallery are available. Please be back later." buttonText="Back to Home" link='/' />
                                    </div>
                                    :
                                    (!galleryLoading && !galleryError && visibleItems && !visibleItems.length) ?
                                        // <ErrorComponent errorCode="404" mainError="Oops...! No Courses are available." />
                                        <ErrorComponent errorCode="404" mainError="Failed to get our gallery right now." subText="Please return to the site's homepage, It looks like nothing was found at this location" buttonText="Back to Home" link='/' />
                                        :
                                        <>
                                            <div className="row y-gap-30 pt--50">
                                                {
                                                    (visibleItems || []).map((item, index) => (
                                                        <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={item.id}>
                                                            {/* Render event component */}
                                                            {/* <EventTwo data={item} /> */}
                                                            {/* <NewGalleryItem data={item} /> */}
                                                            <PostYouTubeVideo data={item} index={index} onVideoToggle={handleVideoToggle} isDedicatedPage={true} onOpenDrawer={handleOpenDrawer} onFilterChange={handleFilterChange} activeFilter={activeFilter} />
                                                        </div>
                                                    ))
                                                }

                                                <div className="video-lightbox-wrapper">
                                                    <FsLightbox
                                                        toggler={toggler}
                                                        sources={[videoUrl]}
                                                        maxYoutubeVideoDimensions={{ width: 1920, height: 1080 }}
                                                    />
                                                </div>

                                                {selectedItem && (
                                                    <GalleryDrawer
                                                        show={openDrawer}
                                                        classes={null}
                                                        onClose={handleHideDrawer}
                                                        data={selectedItem}
                                                        onVideoToggle={handleVideoToggle}
                                                        title={"Salesforce Tutorials Info"}
                                                        isLoading={galleryLoading}
                                                    />
                                                )}
                                            </div>
                                            <div className="row text-center mt--60">
                                                <div className="col-lg-12">
                                                    <button
                                                        className="edu-btn"
                                                        onClick={handleLoadMoreBtn}
                                                        disabled={noMorePost ? 'disabled' : null} // Disable button if no more posts
                                                    >
                                                        {
                                                            noMorePost ? (
                                                                'All Videos Displayed' // Message when all posts are shown 
                                                            ) : (
                                                                <span>
                                                                    Load More
                                                                    <span className="eduvibe-spin-icon">
                                                                        {/* Spinner icon */}
                                                                        <FaSpinner />
                                                                    </span>
                                                                </span>
                                                            )
                                                        }
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default Gallery;